import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';
import { ROUTES } from '@constants/route.constant';
import Layout from '@components/Layout';

const PastTransactions = lazy(() => import('@pages/PastTransactions'));
const TransactionDetail = lazy(() => import('@pages/TransactionDetail'));
const DealPrivilegeDetail = lazy(() => import('@pages/DealPrivilegeDetail'));
const Redemption = lazy(() => import('@pages/Redemption'));
const Referral = lazy(() => import('@pages/Referral'));
const Promotions = lazy(() => import('@pages/Promotions'));
const QRCode = lazy(() => import('@pages/QRCode'));
const ContactUs = lazy(() => import('@pages/ContactUs'));
// Home page should NOT be lazy loaded - it's the critical first page
import Home from '@pages/Home';

import Error from '@components/Error';
import ServiceDownImg from '@assets/images/error/service-down.svg';
import { ERROR_MESSSAGES } from '@constants/common.constants';

export const router = createBrowserRouter([
	{
		path: '/',
		element: <Layout />,
		errorElement: (
			<Error
				img={<ServiceDownImg width='100%' height='100%' />}
				title={ERROR_MESSSAGES.SERVICE_DOWN.TITLE}
				description={
					<>
						<p>{ERROR_MESSSAGES.SERVICE_DOWN.DESCRIPTION}</p>
						<p className='mt-6 tablet:mt-0'>{ERROR_MESSSAGES.SERVICE_DOWN.SUB_DESCRIPTION}</p>
					</>
				}
				btnText={ERROR_MESSSAGES.SERVICE_DOWN.BTN_TEXT}
				btnCallback={() => window.location.reload()}
			/>
		),
		children: [
			{
				index: true,
				element: <Home />,
			},
			{
				path: ROUTES.PROMOTIONS,
				element: <Promotions />,
			},
			{
				path: `${ROUTES.PROMOTIONS}/:id`,
				element: <DealPrivilegeDetail />,
			},
			{
				path: ROUTES.TRANSACTIONS,
				element: <PastTransactions />,
			},
			{
				path: `${ROUTES.TRANSACTIONS}/:id`,
				element: <TransactionDetail />,
			},
			{
				path: `${ROUTES.REDEMPTIONS}/:id`,
				element: <Redemption />,
			},
			{
				path: 'qr-code',
				element: <QRCode />,
			},
			{
				path: 'contact-us',
				element: <ContactUs />,
			},
			{
				path: 'referral',
				element: <Referral />,
			},
			{
				path: '*',
				element: <Home />,
			},
		],
	},
]);
